import type { GetActivitiesSectionsQuery } from '../../../lesson-builder.graphql.generated';
import { ComponentInteractiveResponseCategorise } from '../../component.constants';
import { DropItem } from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drag-drop.constants';
import { DropItem as DropItemSmall } from './play/interactive-response-categorise-small.constants';
import type { Pluck } from 'lib/gql/pluck';

export type ViewProps = Omit<
  ComponentInteractiveResponseCategorise,
  '__typename'
>;
export type EditProps = ViewProps;
export type SettingProps = EditProps & {
  contentId: number;
};

export type InteractiveResponseCategoriseProperties = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesCategoriseResponseComponent' }
  >,
  'properties'
>;
export type InteractiveResponseCategoriseItem = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesCategoriseResponseComponent' }
  >,
  'properties.interactiveResponseCategorise.items'
>;
export type InteractiveResponseCategoriesCategory = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesCategoriseResponseComponent' }
  >,
  'properties.interactiveResponseCategorise.categories'
>;

export type CategoryOption = {
  label: string;
  value: string;
};

export type InteractiveCategoriseAttempt = (dropItems: DropItem[]) => void;

export type InteractiveCategoriseSmallAttempt = (
  dropItems: DropItemSmall[]
) => void;

export const INITIAL_SETUP_DURATION = 600;

export const RESPONSE_FIXED = 'fixed';
export const RESPONSE_FREE = 'free';

export const CATEGORISE_DROP_ITEM_SIZE = 88;
